// extracted by mini-css-extract-plugin
export default {"description":"news_description__Y5sTC","content":"news_content__MPENP"};